module.exports = __webpack_public_path__ + "img/user1.583aae6e.jpg";